module.exports = __webpack_public_path__ + "static/media/0_2019_12_28.6e4f1c06.jpg";